import { Component, Renderer2, SecurityContext, NgZone, AfterViewInit } from '@angular/core';
import { GlobalConstants } from '../../global-constants';
import { QueryService } from '../../comun/services/query.service';
import { FuncionesService } from '../../comun/services/funciones.service';
import { DomSanitizer } from '@angular/platform-browser';
//import { ReCaptcha2Component } from 'ngx-captcha';
import { jwtDecode, JwtPayload } from "jwt-decode";
import { BehaviorSubject, pipe } from 'rxjs';
import { LoaderService } from '../../comun/services/loader.service';
declare const google: any;

export interface GoogleUser {
  sub: string;            // ID único del usuario en Google
  email: string;
  email_verified: boolean;
  name: string;
  picture: string;
  given_name: string;
  family_name: string;
  iat: number;
  exp: number;
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrl: './register.component.css'
})
export class RegisterComponent {
  global: any = GlobalConstants;
  usuario = {username: '', 
             password: '',
             passwordconf: '',
             tipo: 'U', // Usuario
             nombre: '',
             slug: '',
             google_sub: '',
             picture: '',
             mayordeedad: '',
             acepto: '',
             };
  busy = false;
  registrado = false;
  error: string = '';
  siteKey: string = GlobalConstants.siteKey;
  backgroundImage = GlobalConstants.urlServer + '/img/perro-register.png';
  private userSubject = new BehaviorSubject<any>(null);
  showPassword: boolean = false;
  showPasswordConfirm: boolean = false;
  misdatos: any = {};

  constructor(private renderer: Renderer2,
              private query: QueryService,
              private funciones: FuncionesService,
              private sanitizer: DomSanitizer,
              private ngZone: NgZone,
              private loader: LoaderService) {}

  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if (typeof google !== 'undefined') {
        clearInterval(interval);

        // https://console.cloud.google.com/
        google.accounts.id.initialize({
          client_id: '934921995714-9r5vnan638c8d3s495mfnebq5pgrl5e6.apps.googleusercontent.com',
          callback: (response: any) => this.handleCredentialResponse(response)
        });

        google.accounts.id.renderButton(
          document.getElementById("google-btn"),
          { theme: "outline", size: "large" }  // opciones de estilo
        );
      }
    }, 100);
  }

  handleCredentialResponse(response: any) {
    this.ngZone.run(() => {
      // Aquí recibes el JWT de Google
      const token = response.credential;
      // Guardar el token en localStorage
      //localStorage.setItem('google_token', token);

      const user: GoogleUser = jwtDecode<GoogleUser>(token);
      this.ngZone.run(() => {
        this.userSubject.next(user);
        //localStorage.setItem('googleUser', JSON.stringify(user));
        this.usuario.nombre = user.name;
        this.usuario.username = user.email;
        this.usuario.google_sub = user.sub;
        this.usuario.picture = user.picture
        this.registro(false);
      });
      //this.userData = user;
    });
  }

  sanitizar() {
    // Sanitizamos los valores de los campos antes de enviarlos al servidor
    //this.usuario.pu_nombre = this.sanitizer.sanitize(SecurityContext.HTML, this.usuario.pu_nombre) || '';
    this.usuario.username = this.sanitizer.sanitize(SecurityContext.HTML, this.usuario.username) || '';
    this.usuario.password = this.sanitizer.sanitize(SecurityContext.HTML, this.usuario.password) || '';
  }

  // Mensajes concretos y comprensibles para cada campo.
  validarDatos(): string {
    const email = this.usuario.username.trim();
    if (!email) return 'Introduce tu correo electrónico para crear la cuenta.';
    if (!this.funciones.validateEmail(email)) return 'El correo electrónico no parece válido. Comprueba que tenga el formato nombre@dominio.com.';
    if (!this.usuario.password) return 'Crea una contraseña para proteger tu cuenta.';
    if (!this.funciones.validarContrasena(this.usuario.password))
      return 'La contraseña debe tener entre 8 y 48 caracteres, incluir mayúsculas, minúsculas y números, y no contener espacios.';
    if (!this.usuario.passwordconf) return 'Repite la contraseña para confirmar que la has escrito correctamente.';
    if (this.usuario.password !== this.usuario.passwordconf) return 'Las contraseñas no coinciden. Comprueba ambos campos e inténtalo de nuevo.';
    if (!this.usuario.mayordeedad) return 'Para registrarte en iGuau debes confirmar que tienes al menos 18 años.';
    if (!this.usuario.acepto) return 'Para continuar, debes aceptar la política de privacidad y el aviso legal.';
    return '';
  }

  validarDatosGoogle(): string {
    if (!this.usuario.mayordeedad) return 'Para continuar con Google, confirma que tienes al menos 18 años.';
    if (!this.usuario.acepto) return 'Para registrarte con Google, acepta la política de privacidad y el aviso legal.';
    return '';
  }

  private escaparHtml(valor: string): string {
    return valor.replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  private mensajeServidor(resultado: any): string {
    const mensaje = typeof resultado?.mensaje === 'string' ? resultado.mensaje.trim() : '';
    if (!mensaje) return 'No hemos podido completar el registro. Inténtalo de nuevo dentro de unos minutos.';
    // Los mensajes del backend se muestran solo como texto, nunca como HTML.
    return mensaje;
  }

  private enviarCorreosRegistro(id: number): void {
    const nombreSeguro = this.escaparHtml(this.usuario.nombre.trim());
    const saludo = nombreSeguro ? `¡Hola, ${nombreSeguro}!` : '¡Hola!';
    const contenidoUsuario = `
      <p style="margin:0 0 16px;font-size:17px;font-weight:700;color:#385B4B;">${saludo}</p>
      <p>¡Te damos la bienvenida a <strong>iGuau</strong>! Tu cuenta ya está creada y puedes empezar a disfrutar de nuestra comunidad.</p>
      <p>Estos son algunos de tus primeros pasos:</p>
      <ul style="padding-left:21px;line-height:1.9;">
        <li><strong>Completa tu perfil</strong> para que otras personas puedan conocerte.</li>
        <li><strong>Añade a tus mascotas</strong> y comparte sus mejores fotografías.</li>
        <li><strong>Descubre nuevos amigos</strong>, comparte publicaciones y organiza paseos.</li>
        <li><strong>Cuida de tus mascotas</strong> con recordatorios de salud y cuidados.</li>
      </ul>
      <p>Cuando quieras, entra en iGuau y empieza a dejar huella.</p>
      <p style="color:#52675B;font-size:13px;">Si no has creado esta cuenta, contacta con nuestro equipo desde la web para que podamos ayudarte.</p>
      <p style="margin-top:20px;">¡Nos vemos en iGuau!<br><strong>El equipo de iGuau</strong></p>`;

    this.query.enviarMail({
      plantilla: 'general.html', us_id: id, tipo: 'ACTIVIDAD',
      asunto: '¡Bienvenido a iGuau! Ya puedes empezar a dejar huella',
      contenido: contenidoUsuario, botonurl: GlobalConstants.urlWeb,
      boton: 'Entrar en iGuau', estado: 'enviado', contacto: ''
    }).subscribe({
      error: (err: any) => console.warn('No se pudo enviar el correo de bienvenida.', err)
    });

    const correoSeguro = this.escaparHtml(this.usuario.username.trim());
    const metodo = this.usuario.google_sub ? 'Google' : 'Correo y contraseña';
    const contenidoAdministrador = `
      <p style="margin:0 0 14px;font-size:17px;font-weight:700;color:#385B4B;">Nuevo registro en iGuau</p>
      <p>Se ha creado una nueva cuenta de usuario. Estos son los datos de referencia:</p>
      <table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:14px 0;background:#FAF9F5;">
        <tr><td style="padding:10px 12px;color:#52675B;">ID de usuario</td><td style="padding:10px 12px;font-weight:700;">${id}</td></tr>
        <tr><td style="padding:10px 12px;color:#52675B;">Correo electrónico</td><td style="padding:10px 12px;word-break:break-word;">${correoSeguro}</td></tr>
        <tr><td style="padding:10px 12px;color:#52675B;">Método de registro</td><td style="padding:10px 12px;">${metodo}</td></tr>
      </table>
      <p>Este mensaje es informativo. Si necesitas comprobar la cuenta, puedes acceder al panel de administración.</p>
      <p style="font-size:13px;color:#52675B;">Notificación automática de iGuau. No respondas a este correo.</p>`;

    this.query.enviarMail({
      plantilla: 'general.html', us_id: 0, tipo: 'ACTIVIDAD',
      asunto: 'iGuau · Nuevo usuario registrado',
      contenido: contenidoAdministrador,
      botonurl: GlobalConstants.urlWeb.replace(/\/$/, '') + '/wp-admin/',
      boton: 'Abrir administración', estado: 'enviado', contacto: ''
    }).subscribe({
      error: (err: any) => console.warn('No se pudo enviar la notificación de registro al administrador.', err)
    });
  }

  registro(validar: boolean): void {
    if (this.busy) return;
    this.error = '';
    if (validar) {
      this.usuario.username = this.usuario.username.trim();
      this.error = this.validarDatos();
    } else {
      this.error = this.validarDatosGoogle();
    }
    if (this.error) return;

    this.busy = true;
    this.loader.show();
    this.usuario.slug = this.funciones.generateSlug(this.usuario.nombre);
    this.query.query('register', null, this.usuario).subscribe({
      next: (resultado: any) => {
        if (!resultado || resultado.resultado === 'ERROR') {
          this.busy = false;
          this.loader.hide();
          this.error = this.mensajeServidor(resultado);
          return;
        }
        const id = Number(resultado.id);
        if (Number.isInteger(id) && id > 0) this.enviarCorreosRegistro(id);
        this.acceso();
      },
      error: () => {
        this.busy = false;
        this.loader.hide();
        this.error = 'No hemos podido conectar con iGuau. Comprueba tu conexión e inténtalo de nuevo. Si el problema continúa, contacta con soporte.';
      }
    });
  }

  acceso(): void {
    this.busy = true;
    this.loader.show();
    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe({
      next: (resultado: any) => {
        if (!resultado || resultado.resultado === 'ERROR') {
          this.error = 'Tu cuenta se ha creado, pero no hemos podido abrir tu perfil automáticamente. Inicia sesión desde la página de acceso.';
          this.registrado = true;
          this.busy = false;
          this.loader.hide();
          return;
        }
        const datos = Array.isArray(resultado) ? resultado[0] : resultado;
        const slug = datos?.slug;
        if (!slug) {
          this.error = 'Tu cuenta ya está creada. Inicia sesión para acceder a tu perfil.';
          this.registrado = true;
          this.busy = false;
          this.loader.hide();
          return;
        }
        window.location.href = GlobalConstants.urlServer + 'perfil/' + encodeURIComponent(slug);
      },
      error: () => {
        this.error = 'Tu cuenta ya está creada, pero no hemos podido abrir tu perfil. Puedes iniciar sesión desde la página de acceso.';
        this.registrado = true;
        this.busy = false;
        this.loader.hide();
      }
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordConfirm() {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

}
